import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./store";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import mybotgpTheme from "./theme/mybotgpTheme";

// const theme = createTheme({
//   components: {
//     MuiListItem: {
//       styleOverrides: {
//         root: {
//           "&.Mui-selected": {
//             backgroundColor: "#1976d2",
//             color: "#fff",
//           },
//           "&.Mui-selected:hover": {
//             backgroundColor: "#115293",
//           },
//         },
//       },
//     },
//   },
// });

const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={mybotgpTheme}>
      <App />
    </ThemeProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
